// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"9626f023","977":"eecbf9ea"}[chunkId] + ".chunk.js";
};